export class Params {

    private methodParams: string[];     //what parameter types does the method take?
    private paramsDetails: string[];    //what is the param used for?
    private paramsName: string[];       //what is the variable for each param called?

    constructor(methodParams:string[],paramsDetails:string[], paramsName:string[] )
    {

        this.methodParams = methodParams;
        this.paramsDetails = paramsDetails;
        this.paramsName = paramsName;

    }

    public getParams(){
        return this.methodParams.slice();       //returns copy of array
    }

    public getParamSize():number{
        return this.methodParams.length;       //returns size of array
    }

    public getParamDetails()
    {
        return this.paramsDetails.slice();
    }

    public getParamsName(){
        return this.paramsName.slice();
    }

    public iterator(){
        return new Array<String>(this.getParamSize());
    }



}